import { createFileRoute } from "@tanstack/react-router";
import { guardWorkspaceAccess } from "@/lib/workspaceGuard";
import { OnboardingAuthGate } from "@/components/onboarding/OnboardingAuthGate";
import { OnboardingPurpose } from "@/components/onboarding/OnboardingPurpose";
import { useOnboardingStepEvent } from "@/lib/useOnboardingStepEvent";

export const Route = createFileRoute("/onboarding/$workspaceId/purpose")({
  ssr: false,
  beforeLoad: guardWorkspaceAccess,
  component: OnboardingPurposeRoute,
});

function OnboardingPurposeRoute() {
  useOnboardingStepEvent("purpose");
  const { workspaceId } = Route.useParams();
  return (
    <OnboardingAuthGate>
      <OnboardingPurpose workspaceId={workspaceId} />
    </OnboardingAuthGate>
  );
}
